/* global I18n */
I18n.defaultLocale = 'en';
I18n.locale = window.document.documentElement.lang;

// set language direction
const rtlLanguages = ['ar', 'ar-MA'];

I18n.dir = rtlLanguages.indexOf(I18n.locale) !== -1 ? 'rtl' : 'ltr';
document.body.dir = I18n.dir
document.documentElement.dir = I18n.dir


if ( process.env.NODE_ENV === 'test') {
  I18n.missingTranslation = function (scope, options) { console.error('I18n key missing : ' + scope); };
}
